import { style } from '@vanilla-extract/css';

import columnsStyles from '../columnsElement/Columns.css';

const {
  alignLeft,
  alignCenter,
  alignRight,
  alignTop,
  alignMiddle,
  alignBottom,
  stackHorizontal,
  stackVertical,
  mobileHorizontalScroll,
  mobileHorizontalSqueeze,
} = columnsStyles;

const columnItemElement = style({
  position: 'relative',
  display: 'flex',
  direction: 'ltr', // see Columns.css.ts ⭐️
  flexDirection: 'column',
  justifyContent: 'var(--justify-content, flex-start)',
  alignItems: 'var(--align-items, stretch)',
  // width: "calc( var(--width) - ( var(--width-float) * var(--gap-total-width)))",
  borderRadius: 'var(--border-radius)',
  borderWidth: 'var(--border-width)',
  borderColor: 'var(--border-color)',
  borderStyle: 'var(--border-style)',
  scrollSnapAlign: 'start',
  scrollSnapStop: 'normal',
  selectors: {
    [`${alignTop} > &`]: {
      justifyContent: 'flex-start',
    },
    [`${alignMiddle} > &`]: {
      justifyContent: 'center',
    },
    [`${alignBottom} > &`]: {
      justifyContent: 'flex-end',
    },
    [`${alignLeft} > &,
      ${alignRight} > &,
      ${alignCenter} > &
    `]: {
      maxWidth: 'fit-content',
    },
  },
  '@media': {
    'only screen and (--mobile)': {
      width: 'calc( var(--width) - ( var(--width-float) * var(--gap-mobile-total-width) ) )',
      selectors: {
        [`${stackVertical} > div > &`]: {
          width: '100%',
          maxWidth: '100%',
        },
        [`${stackHorizontal} > ${alignCenter}:not(${mobileHorizontalSqueeze}) > &,
          ${stackHorizontal} > ${alignLeft}:not(${mobileHorizontalSqueeze}) > &,
          ${stackHorizontal} > ${alignRight}:not(${mobileHorizontalSqueeze}) > &,
          ${stackHorizontal} > ${mobileHorizontalScroll} > &`]: {
          maxWidth:
            'calc( (var(--width-float) * var(--column-width)) - (var(--width-float) * var(--gap-mobile-total-width)) )',
          width: 'fit-content',
        },
      },
    },
  },
});

export default {
  columnItemElement,
};
